import { Activity } from 'botframework-directlinejs';

export interface IResponseSources {
  Title: string;
  Url: string;
}

export interface IResponseSiteLinks {
  DisplayName: string;
  Url: string;
}

export interface IBotOutgoingMessageValue {
  QuestionId?: string;
  Sources?: IResponseSources[];
  SiteLinks?: IResponseSiteLinks[];
  Features?: string[];
}

// https://msasg.visualstudio.com/Bing_Ads/_git/AdsAppsMT?path=%2Fprivate%2FCampaign%2FMT%2FSource%2FAdsCopilot%2FAdsCopilotMT.Library%2FModel%2FStaticMessageFactory.cs
export type StaticMessageType = 'ResponsibleAI' | 'ConnectToAgent' | 'OutofScope' | 'LargePayload' | 'InternalError' | 'Welcome' | 'SignInError' | 'MissingArgumentsInPayload' | 'TurnLimitReached' | 'TokenExpired' | 'TokenExpiredAutoReload' | 'StreamingCancelled' | 'EmptyReplyToIdToCancelStreaming' | 'Timeout' | 'ConversationExpired' | 'InvalidPayload' | 'HandoffMessage' | 'ConversationResume' | 'SydneyResponsibleAI' | 'NoDataAvailable' | 'StreamingCompleted';

export type SupportedProduct = 'webui_smart_pages' | 'webui_smart_mode' | 'webui_expert_mode' | 'ucma' | 'ucmt' | 'xandr' | 'xandr_invest' | 'xandr_monetization' | 'xandr_curate' | 'map_dri_copilot' | 'xandr_support' | 'ads_marketing';

export interface IUserMessagePayload {
  BotFlightMode?: string;
  isHiddenFromUser?: boolean;
  Locale?: string;
  Product?: SupportedProduct;
  Timezone?: string;
  QuestionId?: string;
  UxContext?: any;
  Features?: string[];
  options?: object;
  AdditionalContext?: object;
}

export type FeedbackType = 'ThumbsUp' | 'ThumbsDown' | 'None';

export interface ITokenApiPayload {
  userid: string;
  username: string;
}

export interface ITokenApiResponse {
  data: {
    conversationId: string;
    token: string;
    tokenExpiryInSeconds: number;
    userId: string;
    error: any;
  }
}

type DirectLineErrorMessage = 'fetchTokenError' | 'directLineChannelError' | 'directLineExpiredToken';
export interface IDirectLineError {
  message: DirectLineErrorMessage;
}

export const StreamingStatusType = {
  InProgress: 'InProgress',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
};

export type BotActivity = Activity & {
  replyToId?: string,
  value?: {
    StreamingStatus?: string,
    isHiddenFromUser?: boolean,
  } | string,
};
